import { Account } from '@/models/Account'

const getters = {
  belongType(state) {
    if (state.account instanceof Account === false) return ''
    return state.account.belongType
  },
  belongId(state) {
    if (state.account instanceof Account === false) return ''
    return state.account.belongId
  },
  belongName(state) {
    if (state.account instanceof Account === false) return ''
    return state.account.belongName
  },
  userType(state) {
    if (state.account instanceof Account === false) return ''
    return state.account.userType
  },
  isSuperAdmin(state) {
    if (state.account instanceof Account === false) return false
    return state.account.isSuperAdmin
  },
  isSystemOwner(state) {
    if (state.account instanceof Account === false) return false
    return state.account.isSystemOwner
  },
  isAgency(state) {
    if (state.account instanceof Account === false) return false
    return state.account.isAgency
  },
  isNotLessThanAgency(state) {
    if (state.account instanceof Account === false) return false
    return state.account.isSystemOwner || state.account.isAgency
  },
  isAdvertiser(state) {
    if (state.account instanceof Account === false) return false
    return state.account.isAdvertiser
  },
  systemOwnerId(state) {
    if (state.account instanceof Account === false) return false
    return state.account.systemOwnerId
  },
  systemOwner(state) {
    if (state.systemOwner === null) return {}
    return state.systemOwner
  },
  searchResult(state) {
    return state.searchResult
  },
  /**
   * クリエイティブを利用できるかどうか。
   *
   * @return {boolean}
   */
  creativeVisible() {
    return true
  },
  /**
   * シミュレーションを利用できるかどうか
   *
   * @returns {boolean}
   */
  isSimulationVisible(state) {
    return state.account instanceof Account
  },
  /**
   * キャンペーン入稿時にシミュレーション結果を検証するかどうか
   * 本番環境・準本番環境のみバリデーションを実行する
   *
   * @returns {boolean}
   */
  isValidateSimulation() {
    const env = process.env.NODE_ENV
    return env === 'production' || env === 'preproduction'
  },
  accountId(state) {
    return state.account.id
  },
}

export default getters
